import { render, staticRenderFns } from "./TableScada.vue?vue&type=template&id=3168efd2&"
import script from "./TableScada.vue?vue&type=script&lang=js&"
export * from "./TableScada.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports